module.exports = __webpack_public_path__ + "img/icon-foto-perfil.37b1891f.svg";